const constants = {
	defaultPrintWidth: 120,
};

export default constants;
